export default {
    ERROR_NOTIFICATIONS_BLOCKED: "messaging/notifications-blocked",
    ERROR_PERMISSIONS_BLOCKED: "messaging/permission-blocked",
};
